import { render } from "./legoPagingTable.vue?vue&type=template&id=c9a1f488"
import script from "./legoPagingTable.vue?vue&type=script&lang=js"
export * from "./legoPagingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/lego/wrapping/legoPagingTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9a1f488"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9a1f488', __exports__)) {
    api.reload('c9a1f488', __exports__)
  }
  
  module.hot.accept("./legoPagingTable.vue?vue&type=template&id=c9a1f488", () => {
    api.rerender('c9a1f488', render)
  })

}


export default __exports__